module.exports = "/images/house-icon.svg?e24a1fd2d26615fea13ddece895bb87f";